import k from '../constants/k'
import { addHoverEffect, mouse } from '../components/mouse'
import { w, h } from '../state/globals'
import { times } from '../state/globals'

k.loadSprite('menu-background', 'sprites/backgrounds/menu.png')
k.loadSprite('start-button', 'sprites/ui/start.png')

export default () => {
  k.add([k.sprite('menu-background'), k.area(), 'background'])
  const startButton = k.add([
    k.sprite('start-button'),
    k.area(),
    k.anchor('center'),
    k.pos(w - 28, h - 20)
  ])
  const { cursor } = mouse()

  startButton.onClick(() => {
    k.play('pop')
    times.startTime = Date.now()
    k.go('room')
  })
  addHoverEffect(startButton, cursor)
}
